import classNames from "classnames";
import React from "react";

const DisseminationLine = (props: { line: string }) => {
  const { line } = props;
  const isBlank = (!line || /^\s*$/.test(line));

  return <div className={classNames('line', isBlank && 'blank')}>{line}</div>;
}

const DisseminationRequest = (props: {
  diss: string
}) => {
  const { diss } = props;
  const lines = diss.split('\n');

  return (
    <pre className="dissemination-request">
      {
        lines.map((line, index) => <DisseminationLine line={line} key={index} />)
      }
    </pre>
  )
}

export default DisseminationRequest;
